import { vendorService } from '../_config';

export const vendorUrls = {
    getVendorBystoreUuid: vendorService + '/customer/stores/{{storeUuid}}',
    getServingCategoriesByStoreUuid: vendorService + '/customer/stores/{{storeUuid}}/serving-categories',
    getVendorsList: vendorService + '/customer/stores',
    getFilteredProducts: vendorService + '/customer/search/offers',
    getOffersByProductUuid: vendorService + '/customer/search/offers/{{productUuid}}/stores',
    addOfferToCart: vendorService + '/customer/cart/items',
    updateFullfilmentCartItem: vendorService + '/customer/cart/{{cartId}}/items/{{id}}/fulfillment',
    getOfferToCart: vendorService + '/customer/cart',
    getCart: vendorService + '/customer/cart',
    updateCart: vendorService + '/customer/cart/{{cartId}}/items/{{id}}',
    deleteCart: vendorService + '/customer/cart/{{cartId}}',
    deleteOfferFromCart: vendorService + '/customer/cart/{{cartId}}/items/{{id}}',
    setCartCoupon: vendorService + '/customer/cart/carts/{{cartId}}/coupon',
    checkoutCart: vendorService + '/customer/orders/checkout',
    createPaymentForOrder: vendorService + '/customer/orders/orders/{{orderId}}/payments',
    getOrderPaymentOptions: vendorService + '/customer/orders/orders/{{orderId}}/payment-options',
    getSubOrderChangePaymentOptions: vendorService + '/customer/orders/sub-orders/{{subOrderId}}/changes/{{changeId}}/payment-options',
    quoteOrderPayment: vendorService + '/customer/orders/orders/{{orderId}}/payment-quotes',
    quoteSubOrderChangePayment: vendorService + '/customer/orders/sub-orders/{{subOrderId}}/changes/{{changeId}}/payment-quotes',
    listCustomerSubOrderChanges: vendorService + '/customer/orders/sub-orders/{{subOrderId}}/changes',
    payCustomerSubOrderChange: vendorService + '/customer/orders/sub-orders/{{subOrderId}}/changes/{{changeId}}/payments',
    getNearestStores: vendorService + '/customer/stores',
    createProductReview: vendorService + '/customer/products/{{productUuid}}/reviews',
    getReviewByStoreUUID: vendorService + '/customer/store/{{storeUuid}}/reviews'
};
